import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';
import { Link as NavLink } from 'react-router-dom';
import { BLACK, TEAL, GOLDEN_YELLOW } from 'root/theme';
import media from '../../oldpantheon/utils/media';
import Col from '../../oldpantheon/components/Col';
import Link from '../../oldpantheon/components/Link';

const MOBILE_HEADER_WIDTH = `40.625rem`;

export const HeaderContainer = styled.header`
  border-top: solid 10px ${GOLDEN_YELLOW};
  width: 100%;
  top: 0;
  z-index: 1000;
  position: relative;
  @media only screen and (max-width: ${MOBILE_HEADER_WIDTH}) {
    border-top: unset;
  }
`;
HeaderContainer.displayName = `HeaderContainer`;

export const HeaderItemContainer = styled.div`
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1000;
  top: 0;
  width: 100%;
  @media only screen and (max-width: ${MOBILE_HEADER_WIDTH}) {
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.25rem 0.9rem;
    box-shadow: 2px 3px 7px 0px rgba(0,0,0,.1);
    position: fixed;
  }
`;

export const HeaderItem = styled(Col)`
  padding: 0;
`;

export const LogoLink = styled(NavLink)`
  height: 100%;
`;

export const LogoContainer = styled(HeaderItem)`
  ${media.tablet`text-align: center`}
`;

export const HeaderTagline = styled.div`
`;

export const HeaderModalLink = styled(Link)`
  font-size: 1rem;
  background-color: #ffffff;
  padding: .5rem 2rem;
  border-radius: 3rem;
  border: 1px solid ${BLACK};
  color: ${BLACK};
  box-shadow: 3px 3px ${TEAL};
  float: right;
  transition-duration: .15s;
  font-weight: bolder;
  &:hover {
    box-shadow: none;
    transform: translate(3px, 3px);
    color: ${BLACK};
  }
  @media only screen and (max-width: ${MOBILE_HEADER_WIDTH}) {
    margin-top: 0;
    float: none;
  }
`;

export const HeaderLogo = styled(InlineSVG)`
  width: 16.875rem;
  display: block;
  margin: 0 auto;
  @media only screen and (max-width: ${MOBILE_HEADER_WIDTH}) {
    display: none;
  }
`;

export const HeaderLogoMobile = styled(InlineSVG)`
  display: none;
  @media only screen and (max-width: ${MOBILE_HEADER_WIDTH}) {
    display: block;
    width: 2.2rem;
    margin-left: 1.5rem;
  }
`;

export const MenuLogoWrapper = styled.div`
  display: flex;
`;
